/* @flow */

import type { ThermostatFanModeFeature } from "./types";

export default function ThermostatFanMode(feature: ThermostatFanModeFeature) {
  let updateFanModeAction = feature.actions.update_thermostat_fan_mode;

  this.setThermostatFanMode = (value, ids = null) => {
    return this.executeDeviceAction(
      updateFanModeAction,
      {
        value,
        ids,
      },
      { fetchModelWhenDone: true }
    );
  };

  return {
    thermostatFanMode: {
      name: feature.name,
      label: feature.label,
      statusIcon: feature.status_icon,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value,
    },
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/thermostat_fan_mode.js